import { render, staticRenderFns } from "./LocalLoading.vue?vue&type=template&id=08711930"
import script from "./LocalLoading.vue?vue&type=script&lang=js"
export * from "./LocalLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports